import {useTranslation} from 'react-i18next';

import {Box, CardMedia, Grid, Typography} from '@mui/material';

import {bodyPdf, pdfH1} from './styles';
import {ReactComponent as EmpionLogo} from '../../../assets/empion_logo.svg';
import thankYouImage from '../../../assets/pdf/thank_you_page/founders_photo.jpeg';
import {greenColors, orangeColors} from '../../../layouts/theme/designSystem';

export const ThankYouPage = () => {
  const {t} = useTranslation('pdfDomain');
  const {t: ts} = useTranslation('pdfDomain', {keyPrefix: 'thankYouPage.textBlocks'});

  return (
    <>
      <Grid container p={5}>
        <Grid item px={8} mb={3}>
          <Typography variant='h1' sx={pdfH1}>
            {t('thankYouPage.title')}
          </Typography>
          <Typography sx={{mb: 1, ...bodyPdf}}>{ts('one')}</Typography>
          <Typography sx={{mb: 1, ...bodyPdf}}>{ts('two')}</Typography>
          <Typography sx={{mb: 1, ...bodyPdf}}>{ts('three')}</Typography>
          <Typography sx={{mb: 1, ...bodyPdf}}>{ts('four')}</Typography>
          <Typography sx={{mb: 1, ...bodyPdf}}>{ts('five')}</Typography>
        </Grid>

        <Grid item container justifyContent={'center'} mb={9}>
          <CardMedia
            component='img'
            image={thankYouImage}
            sx={{height: '580px', width: '680px', borderRadius: '16px'}}
          />

          <Grid
            container
            direction={'column'}
            alignItems={'center'}
            gap={2}
            mt={'-120px'}
            width={'660px'}
          >
            <Grid item>
              <Box
                bgcolor={orangeColors[5]}
                p={'16px'}
                alignItems={'center'}
                borderRadius={'8px'}
                height={'62px'}
                width={'182px'}
              >
                <EmpionLogo fill={greenColors[900]} height={'30px'} width={'150px'} />
              </Box>
            </Grid>

            <Grid item bgcolor={orangeColors[5]} p={'16px'} borderRadius={'8px'} width={'220px'}>
              <Typography sx={{...bodyPdf, fontWeight: '700'}}>Dr. Annika von Mutius</Typography>
              <Typography sx={bodyPdf}>annika.mutius@empion.io</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
